if ($('.js-product-review').length) {
    $('.js-product-review').each(function() {
        let $productReview = $(this);
        let productReviewId = $productReview.data('product-id');
        let productReviewUrl = $productReview.data('url');
        let productReviewMethod = $productReview.data('method');
        let responseId = $('.js-popup-review-3').data('response-id') || '';

        App.D.on('click', '.js-review-yes', function() {
            let reviewStatus = $(this).data('review-good');

            $.ajax({
                url: productReviewUrl,
                method: productReviewMethod || 'GET',
                data: 'productId=' + productReviewId + '&reviewGood=' + reviewStatus,
                success: (response) => {
                    if (response.success) {
                        $('.js-popup-review-1').removeClass('_active');
                        $('.js-popup-review-2').addClass('_active');
                    } else {
                        console.log(response.message || 'Ошибка от сервера');
                    }
                },
                error: () => {
                    console.log('Ошибка получения данных');
                }
            });
        });

        App.D.on('click', '.js-review-no', function() {
            let url = $(this).data('url');
            let reviewStatus = $(this).data('review-good');

            if ($(this).closest('.js-product-review-self').length){
                $('.js-popup-review-1').removeClass('_active');
                $('.js-popup-review-3').addClass('_active');
            } else {
                $.ajax({
                    url: url,
                    method: 'GET',
                    data: 'productId=' + productReviewId + '&reviewGood=' + reviewStatus,
                    success: (response) => {
                        if (response.success) {
                            $('.js-popup-review-3').attr('data-response-id', response.id);
                            responseId = response.id;

                            $('.js-popup-review-1').removeClass('_active');
                            $('.js-popup-review-3').addClass('_active');
                            let attrNoBtn = $(this).attr('data-no-btn');

                            if(!$(this).hasClass('js-review-no-open-popup')) {
                                if(typeof attrNoBtn !== 'undefined' && attrNoBtn !== false) {
                                    $('.js-popup-review-3').addClass('_hidden-btn');
                                    $('.js-review-no-reason').addClass('_next-popup');
                                    $('.js-review-no-reason').removeAttr('data-popup');
                                } else {
                                    $('.js-popup-review-3').removeClass('_hidden-btn');
                                    $('.js-review-no-reason').removeClass('_next-popup');
                                    $('.js-review-no-reason').attr('data-popup', 'preAskQuestion');
                                }

                                if($(this).closest('.js-popup-review-2').hasClass('_active')) {
                                    $('.js-popup-review-2').removeClass('_active');
                                }
                            }
                        } else {
                            console.log(response.message || 'Ошибка от сервера');
                        }
                    },
                    error: () => {
                        console.log('Ошибка получения данных');
                    }
                });
            }
        });

        App.D.on('click', '.js-review-no-reason', function() {
            // let responseId = $('.js-popup-review-3').data('response-id');
            let url = $('.js-popup-review-3').data('url');
            let textReason = $(this).data('text');

            if ($(this).closest('.js-product-review-self').length){
                $('.js-popup-review-3').removeClass('_active');
                if ($(this).data('reason') == 'quality') {
                    $('.js-popup-review-4').addClass('_active');
                } else if ($(this).data('reason') == 'reaction') {
                    $('.js-popup-review-5').addClass('_active');
                }
            } else {
                $.ajax({
                    url: url,
                    method: 'POST',
                    data: 'responseId=' + responseId + '&reviewReason=' + textReason,
                    success: (response) => {
                        if (response.success) {
                            console.log('ID полученен');

                            $('.js-popup-review-3').removeClass('_active');

                            if(!$(this).hasClass('_next-popup')) {
                                $('.js-review-no-open-popup').data('reason', $(this).data('reason'));
                                $('.js-common-popup[data-name="preAskQuestion"]').addClass('common-popup--opened');
                            } else {
                                if ($(this).data('reason') == 'quality') {
                                    $('.js-popup-review-4').addClass('_active');
                                } else if ($(this).data('reason') == 'reaction') {
                                    $('.js-popup-review-5').addClass('_active');
                                } else if ($(this).data('reason') == 'originality') {
                                    $('.js-popup-review-6').addClass('_active');
                                } else if ($(this).data('reason') == 'effect') {
                                    $('.js-popup-review-7').addClass('_active');
                                }
                            }
                            $('.popup-review-step._active').find('.js-id-response').val(responseId);
                        } else {
                            console.log(response.message || 'Ошибка от сервера');
                        }
                    },
                    error: () => {
                        console.log('Ошибка получения данных');
                    }
                });
            }


        });

        App.D.on('click', '.js-review-no-open-popup', function() {
            // let responseId = $('.js-popup-review-3').data('response-id');

            $('.js-popup-review-1').removeClass('_active');
            $('.js-popup-review-3').removeClass('_active');
            $(this).closest('.js-common-popup').removeClass('common-popup--opened');
            $('.js-common-popup[data-name="productReview"]').addClass('common-popup--opened');
            if ($(this).data('reason') == 'quality') {
                $('.js-popup-review-4').addClass('_active');
            } else if ($(this).data('reason') == 'reaction') {
                $('.js-popup-review-5').addClass('_active');
            } else if ($(this).data('reason') == 'originality') {
                $('.js-popup-review-6').addClass('_active');
            } else if ($(this).data('reason') == 'effect') {
                $('.js-popup-review-7').addClass('_active');
            }

            $('.popup-review-step._active').find('.js-id-response').val(responseId);
        });
    });
}
